import { graphql } from "@opensea/graphql"

export const SwapDetailsEstimatedDurationItemFragment = graphql(
  `
    fragment SwapDetailsEstimatedDurationItem on SwapRouteResult {
      ... on SwapRoute {
        estimatedDurationMs
      }
    }
  `,
  [],
)
